import { ContentWrapper } from '@/components/_common';
import { Col, Row, Typography } from 'antd';
import React from 'react';

import { WorkOrderQRCodeResponse } from '@/core/domain/workorder/QRCode/QRCode.types';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { quantityFormatter } from '@/utils/number';

interface Props {
  data?: WorkOrderQRCodeResponse;
}

const WorkOrderViewPublicListTasks: React.FC<Props> = ({ data }) => {
  return (
    <>
      <Typography.Title level={4}>Serviços</Typography.Title>

      {data?.complements.map((complement) =>
        complement.items
          .filter((item) => item.type === WorkOrderItemType.Service)
          .map((item) => {
            return (
              <ContentWrapper
                style={{
                  marginBottom: 10,
                }}
              >
                <Row gutter={[24, 24]}>
                  <Col span={24}>
                    <Row gutter={2}>
                      <Col span={24}>
                        <Typography.Title level={4} style={{ marginBottom: 0 }}>
                          {item.description}
                        </Typography.Title>
                      </Col>

                      <Col span={24}>{`Qtd./Tempo - ${quantityFormatter(
                        item.quantity,
                      )}`}</Col>
                    </Row>
                  </Col>
                </Row>
              </ContentWrapper>
            );
          }),
      )}
    </>
  );
};

export default WorkOrderViewPublicListTasks;
